export const PRE_UNDERWRITING = 'preunderwriting'
export const PRE_UNDERWRITING_COMPANY_INTRODUCTION = 'company-introduction'
export const PRE_UNDERWRITING_COMPANY_FINANCIALS = 'company-financials'
export const PRE_UNDERWRITING_BUYER_DETAILS = 'buyer-details'
export const PRE_UNDERWRITING_STEPS = [
  PRE_UNDERWRITING_COMPANY_INTRODUCTION,
  PRE_UNDERWRITING_COMPANY_FINANCIALS,
  PRE_UNDERWRITING_BUYER_DETAILS,
]

export const COMPANY_SELECT_NONE_TEXT = 'none-of-the-above'

export const SECTION_PRE_UNDERWRITING_COMPANY_INTRODUCTION = `${PRE_UNDERWRITING}.${PRE_UNDERWRITING_COMPANY_INTRODUCTION}`
export const COMPANY_NAME_SELECT = 'company.companyNameSelect'
export const COMPANY_FOUNDATION_MONTH = 'company.foundationDateMonth'
export const COMPANY_FOUNDATION_YEAR = 'company.foundationDateYear'

export const SECTION_PRE_UNDERWRITING_COMPANY_FINANCIALS = `${PRE_UNDERWRITING}.${PRE_UNDERWRITING_COMPANY_FINANCIALS}`

export const SECTION_PRE_UNDERWRITING_BUYER_DETAILS = `${PRE_UNDERWRITING}.${PRE_UNDERWRITING_BUYER_DETAILS}`

export const preunderwritingSubmitStateKeyPrefix = 'hasUserSubmitedPreunderwriting'
